module.exports = __webpack_public_path__ + "img/kommune-1539.e3ed0696.svg";